import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import arrayMutators from 'final-form-arrays';
import { Box, FormHelperText, Grid2 } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import { Form } from 'react-final-form';
import ActionButtons from '../ActionButtons';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { FieldArray } from 'react-final-form-arrays';
import QuantityRangeFields from 'modules/Pricing/components/QuantityRangeFields';

const EditRangesForm = ({ priceGroupId, handleClose }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_id.edit_ranges_form.${key}`);
    const { submittingPriceGroup, prices, validateRanges, editRanges } = usePriceGroup();
    const initialValues = useMemo(() => ({ ranges: [...prices.map(({ quantityFrom, quantityTo }, index) => ({ id: index + 1, quantityFrom, quantityTo }))] }), [prices]);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async ({ ranges }) => {
        await editRanges(priceGroupId, initialValues?.ranges, ranges);
        handleClose();
    };

    const validateForm = ({ ranges = [] }) => {
        const hasChanges = ranges.some((range, index) => {
            const initialRange = initialValues.ranges[index];
            return range.quantityFrom !== initialRange.quantityFrom || range.quantityTo !== initialRange.quantityTo;
        });
        if (!hasChanges) return { edit: translate('validate_form.edit') };

        return validateRanges(ranges);
    };

    return (
        <Form
            key={`edit-price-group-form-ranges-${priceGroupId}`}
            mutators={{ ...arrayMutators }}
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={initialValues}
            render={({ handleSubmit, form, values, errors }) => {
                const ranges = values.ranges || [];
                const lastRange = ranges[ranges.length - 1] || {};
                const lastToEmpty = lastRange.quantityTo === '' || lastRange.quantityTo === undefined;

                return (
                    <form key={`edit-price-group-form-ranges-${priceGroupId}`} onSubmit={handleSubmit} noValidate>
                        <Box component="section" py={2}>
                            <Title title={translate('title')} description={translate('description')} />

                            {/* Form */}
                            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                                <FieldArray name="ranges">{({ fields }) => <QuantityRangeFields fields={fields} lastToEmpty={lastToEmpty} />}</FieldArray>
                                {errors.edit && submitted && <FormHelperText error={errors.edit}>{errors.edit}</FormHelperText>}
                            </Grid2>

                            <ActionButtons
                                handleSubmit={(e) => {
                                    setSubmitted(true);
                                    return handleSubmit(e);
                                }}
                                handleClose={(e) => {
                                    handleClose();
                                    return form.reset(e);
                                }}
                                submitting={submittingPriceGroup}
                                labelNext={translate('edit_button')}
                            />
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default EditRangesForm;
